var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["macros/super-navigation-macro.j2"] = require( "macros/super-navigation-macro.j2" );
dependencies["macros/tiered-navigation-macro.j2"] = require( "macros/tiered-navigation-macro.j2" );
dependencies["macros/enhanced-tiered-navigation-macro.j2"] = require( "macros/enhanced-tiered-navigation-macro.j2" );
dependencies["macros/left-primary-navigation.j2"] = require( "macros/left-primary-navigation.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/header/main-navigation.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/header/main-navigation.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("categoryUrl")) {
var t_4 = t_1.categoryUrl;
} else {
cb(new Error("cannot import 'categoryUrl'")); return;
}
context.setVariable("categoryUrl", t_4);
output += "\n";
env.getTemplate("macros/super-navigation-macro.j2", false, "core/templates/header/main-navigation.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("mainNavigationTree")) {
var t_8 = t_5.mainNavigationTree;
} else {
cb(new Error("cannot import 'mainNavigationTree'")); return;
}
context.setVariable("superNavMainNavigationTree", t_8);
output += "\n";
env.getTemplate("macros/tiered-navigation-macro.j2", false, "core/templates/header/main-navigation.j2", false, function(t_10,t_9) {
if(t_10) { cb(t_10); return; }
t_9.getExported(context.getVariables(), frame, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
if(t_9.hasOwnProperty("buildTieredPrimaryNavigation")) {
var t_12 = t_9.buildTieredPrimaryNavigation;
} else {
cb(new Error("cannot import 'buildTieredPrimaryNavigation'")); return;
}
context.setVariable("buildTieredPrimaryNavigation", t_12);
output += "\n";
env.getTemplate("macros/enhanced-tiered-navigation-macro.j2", false, "core/templates/header/main-navigation.j2", false, function(t_14,t_13) {
if(t_14) { cb(t_14); return; }
t_13.getExported(context.getVariables(), frame, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
if(t_13.hasOwnProperty("buildEnhancedTieredPrimaryNavigation")) {
var t_16 = t_13.buildEnhancedTieredPrimaryNavigation;
} else {
cb(new Error("cannot import 'buildEnhancedTieredPrimaryNavigation'")); return;
}
context.setVariable("buildEnhancedTieredNavigation", t_16);
output += "\n";
env.getTemplate("macros/left-primary-navigation.j2", false, "core/templates/header/main-navigation.j2", false, function(t_18,t_17) {
if(t_18) { cb(t_18); return; }
t_17.getExported(context.getVariables(), frame, function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
if(t_17.hasOwnProperty("buildLeftPrimaryNavigation")) {
var t_20 = t_17.buildLeftPrimaryNavigation;
} else {
cb(new Error("cannot import 'buildLeftPrimaryNavigation'")); return;
}
context.setVariable("buildLeftPrimaryNavigation", t_20);
output += "\n\n<div class=\"o-row dom-navigation-container\">\n\n";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"categoryRootNavSlugs")) {
output += "\n\n    ";
var t_21;
t_21 = (lineno = 10, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.deviceCharacteristics.is_smallish",runtime.contextOrFrameLookup(context, frame, "False")])) || (lineno = 10, colno = 91, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.deviceCharacteristics.is_medium",runtime.contextOrFrameLookup(context, frame, "False")]));
frame.set("isSmallishOrMedium", t_21, true);
if(frame.topLevel) {
context.setVariable("isSmallishOrMedium", t_21);
}
if(frame.topLevel) {
context.addExport("isSmallishOrMedium", t_21);
}
if((runtime.contextOrFrameLookup(context, frame, "isSmallishOrMedium"))) {
output += "<div class=\"u-large--hide js-accordion dom-main-navigation\">\n\n            <nav id=\"u-navigation-anchor\" class=\"c-left-navigation\" data-qa-main-navigation>\n\n                ";
output += runtime.suppressValue((lineno = 18, colno = 43, runtime.callWrap(t_20, "buildLeftPrimaryNavigation", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"categoryRootNavSlugs"),runtime.makeKeywordArgs({"selectedLevel1Slug": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"selectedLevel1NavSlug"),"class": "left-navigation"})])), env.opts.autoescape);
output += "\n\n            </nav>\n\n        </div>";
;
}
else {
output += "\n        ";
var t_22;
t_22 = (lineno = 26, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.ab.SS_UOSUPNAV",runtime.contextOrFrameLookup(context, frame, "False")])) == 1;
frame.set("isSuperNavTest", t_22, true);
if(frame.topLevel) {
context.setVariable("isSuperNavTest", t_22);
}
if(frame.topLevel) {
context.addExport("isSuperNavTest", t_22);
}
output += "\n        ";
var t_23;
t_23 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"useSuperNav") || runtime.contextOrFrameLookup(context, frame, "isSuperNavTest");
frame.set("useSuperNav", t_23, true);
if(frame.topLevel) {
context.setVariable("useSuperNav", t_23);
}
if(frame.topLevel) {
context.addExport("useSuperNav", t_23);
}
output += "\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "useSuperNav")) {
output += "\n            ";
var t_24;
t_24 = "s-super-navigation";
frame.set("scopeClass", t_24, true);
if(frame.topLevel) {
context.setVariable("scopeClass", t_24);
}
if(frame.topLevel) {
context.addExport("scopeClass", t_24);
}
output += "\n        ";
;
}
else {
if((lineno = 31, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.constants.useEnhancedTieredNavigation",runtime.contextOrFrameLookup(context, frame, "False")]))) {
output += "\n            ";
var t_25;
t_25 = "s-enhanced-tiered-navigation";
frame.set("scopeClass", t_25, true);
if(frame.topLevel) {
context.setVariable("scopeClass", t_25);
}
if(frame.topLevel) {
context.addExport("scopeClass", t_25);
}
output += "\n        ";
;
}
else {
output += "\n            ";
var t_26;
t_26 = "s-tiered-navigation";
frame.set("scopeClass", t_26, true);
if(frame.topLevel) {
context.setVariable("scopeClass", t_26);
}
if(frame.topLevel) {
context.addExport("scopeClass", t_26);
}
output += "\n        ";
;
}
;
}
output += "\n\n        <div class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "scopeClass"), env.opts.autoescape);
output += " o-row u-extra-small--hide u-large--show dom-main-navigation js-main-navigation\">\n\n            <nav class=\"c-main-navigation\" data-qa-main-navigation>\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "useSuperNav")) {
output += "\n\n                ";
output += runtime.suppressValue((lineno = 43, colno = 43, runtime.callWrap(t_8, "superNavMainNavigationTree", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"categoryRootNavSlugs"),env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"categoryRootNavSlugs")),runtime.makeKeywordArgs({"seeMore": runtime.contextOrFrameLookup(context, frame, "True"),"superNav": runtime.contextOrFrameLookup(context, frame, "True"),"selectedLevel1Slug": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"selectedLevel1NavSlug"),"class": "main-navigation"})])), env.opts.autoescape);
output += "\n\n            ";
;
}
else {
if((lineno = 45, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.constants.useEnhancedTieredNavigation",runtime.contextOrFrameLookup(context, frame, "False")]))) {
output += "\n\n                ";
output += runtime.suppressValue((lineno = 47, colno = 46, runtime.callWrap(t_16, "buildEnhancedTieredNavigation", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"categoryRootNavSlugs"),runtime.makeKeywordArgs({"selectedLevel1Slug": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"selectedLevel1NavSlug"),"class": "main-navigation"})])), env.opts.autoescape);
output += "\n\n            ";
;
}
else {
output += "\n\n                ";
output += runtime.suppressValue((lineno = 51, colno = 45, runtime.callWrap(t_12, "buildTieredPrimaryNavigation", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"categoryRootNavSlugs"),runtime.makeKeywordArgs({"selectedLevel1Slug": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"selectedLevel1NavSlug"),"class": "main-navigation"})])), env.opts.autoescape);
;
}
;
}
output += "</nav>\n\n        </div>\n\n    ";
;
}
output += "\n\n";
;
}
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/header/main-navigation.j2"] , dependencies)